import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

import '@/i18n';
import '@/styles/globals.css';

import { Providers } from './providers';
import { router } from './router';
import { AppErrorBoundary } from '@/shared/components/AppErrorBoundary';
import { Toaster } from '@/shared/components/Toaster';
import { installGlobalErrorHandlers } from '@/shared/lib/reportError';

// Captura de errores no controlados (window.onerror + promesas sin catch) →
// tabla client_errors → aviso inmediato por email.
installGlobalErrorHandlers();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

createRoot(rootEl).render(
  <StrictMode>
    <AppErrorBoundary>
      <Providers>
        <RouterProvider router={router} />
        <Toaster />
      </Providers>
    </AppErrorBoundary>
  </StrictMode>
);
